export function groupStocksBySector(stocks, { origin = "" } = {}) {
  let stocksBySector = {};

  for (const stock of stocks) {
    const sector = stock.sector;

    if (sector) {
      if (!stocksBySector[sector]) {
        stocksBySector[sector] = [];
      }

      stocksBySector[sector].push({
        ticker: origin === "ru" ? stock.ticker.replace("RU:", "") : stock.ticker,
        sector: stock.sector,
        volume: stock.prices.value,
        percentChange: stock.prices.current.priceChangePercent,
        companyName: stock.name.replace(/(^|\s+)привилегированные(\s+|$)/g, " "),
        currency: stock.currency,
        prices: stock.prices,
        origin
      });
    }
  }

  return stocksBySector;
}

